// @storybook-skip: internal section of StatsTabContent; covered by its story
import { useTranslation } from "react-i18next";
import { Text } from "react-native-paper";
import Box from "../Box";
import { MiniStatCard } from "./MiniStatCard";
import { OverallProgressCard } from "./OverallProgressCard";
import type { MiniStat, OverallProgress } from "./types";

type Props = {
	overallProgress: OverallProgress;
	miniStats: MiniStat[];
};

export const ProgressInsightsSection = ({
	overallProgress,
	miniStats,
}: Props) => {
	const { t } = useTranslation();

	return (
		<Box gap={14}>
			<Text variant="titleLarge">{t("lessons.stats.insights.title")}</Text>
			<Box gap={16}>
				<OverallProgressCard progress={overallProgress} />
				<Box flexDirection="row" gap={16}>
					{miniStats.map((stat) => (
						<MiniStatCard
							key={`${stat.label}-${stat.statusText}`}
							stat={stat}
						/>
					))}
				</Box>
			</Box>
		</Box>
	);
};
